/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module WelcomeModule
 */

import {
    CUSTOM_ELEMENTS_SCHEMA,
    NgModule,
    NO_ERRORS_SCHEMA,
} from '@angular/core';

import {
    ClrCheckboxModule,
    ClrFormsModule,
    ClrInputModule,
    ClrStepperModule,
} from '@clr/angular';

import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from 'ng/shared/shared.module';
import { AviFormsModule } from 'ng/modules/avi-forms/avi-forms.module';
import { CoreModule } from 'ng/modules/core/core.module';

import {
    WelcomeEmailAnonymousServerSettingsComponent,
    WelcomeEmailLocalhostSettingsComponent,
    WelcomeEmailSettingsComponent,
    WelcomeEmailSmtpServerSettingsComponent,
    WelcomeModalComponent,
    WelcomeModalContainerComponent,
    WelcomeService,
    WelcomeSystemSettingsComponent,
    WelcomeTenantSettingsComponent,
} from '.';

const welcomeComponents = [
    WelcomeEmailAnonymousServerSettingsComponent,
    WelcomeEmailLocalhostSettingsComponent,
    WelcomeEmailSettingsComponent,
    WelcomeEmailSmtpServerSettingsComponent,
    WelcomeModalComponent,
    WelcomeModalContainerComponent,
    WelcomeSystemSettingsComponent,
    WelcomeTenantSettingsComponent,
];

/**
 * @description
 *
 *      Module for Welcome-flow related services and components.
 *
 * @author Aravindh Nagarajan
 */
@NgModule({
    declarations: [
        ...welcomeComponents,
    ],
    providers: [
        WelcomeService,
    ],
    imports: [
        AviFormsModule,
        BrowserAnimationsModule,
        ClrCheckboxModule,
        ClrFormsModule,
        ClrInputModule,
        ClrStepperModule,
        CoreModule,
        FormsModule,
        SharedModule,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class WelcomeModule {}
